module.exports = __webpack_public_path__ + "img/hr-stone.0ab09dc0.png";